/**
 * Theme quota compatibility helpers.
 *
 * Older B2B draft strategies persisted sprintContract.outputThemeQuotas with
 * `theme`, while newer utilities read `themeId`. Keep reads tolerant so draft
 * review and planner gates do not collapse those quotas into `undefined`.
 */

export interface ThemeRefLike {
  themeId?: string;
  theme?: string;
  id?: string;
}

export function resolveThemeId(ref: ThemeRefLike | undefined | null): string {
  const raw = ref?.themeId ?? ref?.theme ?? ref?.id ?? '';
  return String(raw).trim();
}
